import { createServerFn } from "@tanstack/solid-start";
import { z } from "zod";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const GetBankConnectionsPageDataInputSchema = z.object({
  businessId: z.string().trim().min(1),
});

/**
 * Aggregate server function for the bank connections index page.
 *
 * Fetches business detail and the banking overview (connections + accounts)
 * in a single HTTP round trip on client-side navigation.
 */
export const getBankConnectionsPageData = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => GetBankConnectionsPageDataInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("bankConnections.pageData", async () => {
      const [businessMod, bankingMod] = await Promise.all([
        import("../business/business.server"),
        import("./banking.server"),
      ]);
      const { getBusinessDetailForUser } = businessMod;
      const { getBankingOverviewForUser } = bankingMod;

      const [businessDetail, bankingOverview] = await Promise.all([
        getBusinessDetailForUser(context.user.id, data.businessId),
        getBankingOverviewForUser(context.user.id, data.businessId),
      ]);

      return { businessDetail, bankingOverview } as const;
    });
  });
